import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {Location} from '@angular/common';
import {engEnumNum, plEnumNum} from '../models/general.model';
import {Router} from '@angular/router';

enum LanguageEnum {
    PL = plEnumNum,
    ENG = engEnumNum,
}

@Injectable()
export class GeneralService {

    constructor(
        private _location: Location,
        protected router: Router
    ) {
    }

    public get getLand(): LanguageEnum {
        return this.lang.value;
    }

    // treeMaxLevel: number;

    private lang = new BehaviorSubject(<LanguageEnum>plEnumNum);

    public static checkIfInt(filter): boolean {
        return /^\d+$/.test(filter);
    }

    private static getCategoryByPropName(data: any, propName: string) {
        let category = '';

        for (let i = 1, len = 10; i <= len; i++) {
            if (data[propName + i]) {
                category += ((i > 1) ? '/' : '') + data[propName + i];
            }
        }

        return category;
    }

    public changeLang(newLang: LanguageEnum) {
        this.lang.next(newLang);
    }

    // returns date without time
    public parseDate(strDate: any): string {
        return strDate ? new Date(strDate).toISOString().split('T')[0] : null;
    }

    public parseVAT(vat: number): number {
        return vat !== null && vat !== undefined ? vat * 100 : null;
    }

    public parsePercentage(input: number): number {
        return input !== null && input !== undefined ? input * 100 : null;
    }

    // returns date with time
    public parseDateWithTime(strDate: any): string {
        if (!strDate) {
            return null;
        }
        const dateSplit = new Date(strDate).toISOString().split('T');
        return dateSplit[0] + ' ' + dateSplit[1].slice(0, 5);
    }

    public parseDateWithMonth(strDate: any): string {
        if (!strDate) {
            return null;
        }
        const dateSplit = new Date(strDate).toISOString().split('T');
        return dateSplit[0].slice(0, 7);
    }

    public parseToDate(str_date: string) {
        str_date = String(str_date);
        const pattern = /(\d{4})(\d{2})(\d{2})(\d{2})/;
        return str_date.replace(pattern, '$1-$2-$3');
    }

    public parseToDateShort(str_date: string) {
        str_date = String(str_date);
        const pattern = /(\d{4})(\d{2})(\d{2})/;
        return str_date.replace(pattern, '$1-$2-$3');
    }

    public parseToShortDateFromFileName(str_date: string) {
        str_date = String(str_date).substring(0, 8);
        const pattern = /(\d{4})(\d{2})(\d{2})/;
        return str_date.replace(pattern, '$1-$2-$3');
    }

    public getProductSales(): string {
        return 'MONTH';
    }

    public navigateTo(navigationArray: string[]): void {
        if (navigationArray.length) {
            this.router.navigate(navigationArray);
        }
    }

    public goBack() {
        this._location.back();
    }

    public getFilenameFromHeader(header: string) {
        return header.split(';')[1].split('filename')[1].split('=')[1].trim();
    }

    public deepObjectCopy(obj): any {
        return JSON.parse(JSON.stringify(obj));
    }

    public isValueInEnum(value: any, enumInstance: any): boolean {
        return Object.values(enumInstance).includes(value);
    }

    public toCamelCase(val: string) {
        return val.replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => {
            return index === 0 ? word.toLowerCase() : word.toUpperCase();
        }).replace(/\s+/g, '');
    }

    toUpperCamelCaseObj(val: {}) {
        let newO, origKey, newKey, value;
        if (val instanceof Array) {
            return val.map((tmpVal) => {
                if (typeof tmpVal === 'object') {
                    tmpVal = this.toUpperCamelCaseObj(tmpVal);
                }
                return tmpVal;
            });
        } else {
            newO = {};
            for (origKey in val) {
                if (val.hasOwnProperty(origKey)) {
                    newKey = (origKey.charAt(0).toUpperCase() + origKey.slice(1) || origKey).toString();
                    value = val[origKey];

                    if (value instanceof Array || (value !== null && value.constructor === Object)) {
                        value = this.toUpperCamelCaseObj(value);
                    }
                    newO[newKey] = value;
                }
            }
        }
        return newO;
    }

    getCategoryNameLevel(data, propName = 'CategoryNameLevel') {
        return GeneralService.getCategoryByPropName(data, propName);
    }
}
